let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("czxXO")).then(() => parcelRequire('04Nh9'));